import { useEffect } from 'react';
import { isPassiveEventSupported } from '../../../../../../core/DOMUtils';

export default (elements: any) => {
  useEffect(() => {
    let prevValue = false;

    const play = (direction: any) => {
      for (const elm of elements) {
        elm.classList.remove('animated');
        elm.style.animationDirection = direction;

        // this causes a re-flow which triggers the animation again
        void elm.offsetWidth; // eslint-disable-line no-void

        elm.classList.add('animated');
      }
    };

    const pollScroll = () => {
      const hasScrolled = window.scrollY >= 42;
      if (hasScrolled !== prevValue) {
        prevValue = hasScrolled;
        play(hasScrolled ? 'normal' : 'reverse');
      }
    };

    window.addEventListener('scroll', pollScroll, isPassiveEventSupported());

    return () => window.removeEventListener('scroll', pollScroll, isPassiveEventSupported());
  }, [elements]);
};
